// Словарь интерфейса: ru
const ru = {
  "home": {
    "title": "Главная",
    "description": "Это главная страница нашего сайта.",
    "branches": "Филиалы",
    "invoices": "Счета",
    "warehouse": "Склад",
    "bonuses": "Бонусы",
    "terms": "Условия",
    "contacts": "Контакты",
    "parcels": "Посылки",
    "account": "Аккаунт",
    "calculator": "Калькулятор",
    "dashboard": "Панель управления",
    "banner": "Баннер"
  },
  "about": {
    "title": "О нас",
    "description": "Узнайте больше о нашей компании."
  },
  "contact": {
    "title": "Контакты",
    "description": "Свяжитесь с нами здесь."
  },
  "menu": {
    "instruction": "Инструкция",
    "branches": "Филиалы",
    "warehouseAddress": "Адрес склада",
    "lostItems": "Потеряшки",
    "contacts": "Контакты",
    "copy": "Копировать",
    "aboutUs": "О нас",
    "prohibitedItems": "Товары, которые нельзя заказывать",
    "home": "Главная",
    "parcels": "Посылки",
    "profile": "Профиль",
    "myParcels": "Мои посылки",
    "addTrack": "Добавить трек",
    "archive": "Архив",
    "allParcels": "Все посылки",
    "settings": "Настройки",
    "username": "Код клиента (как в адресе доставки)",
    "saveUsername": "Сохранить",
    "currentPassword": "Текущий пароль",
    "newPassword": "Новый пароль",
    "changePassword": "Сменить пароль",
    "close": "Закрыть",
    "dashboard": "Панель управления",
    "logout": "Выйти",
    "about": "Описание",
    "moreTrack": "Все посылки",
    "passwd": "Пароль",
    "notifications": "Уведомление"
  },
  "common": {
    "loading": "Загрузка...",
    "back": "Назад",
    "cancel": "Отмена",
    "save": "Сохранить",
    "delete": "Удалить",
    "edit": "Редактировать",
    "all": "Все",
    "archive": "Архив",
    "next": "Вперёд",
    "prev": "Назад",
    "page": "Страница {{page}} / {{total}}",
    "none": "—"
  },
  "account": {
    "title": "Аккаунт",
    "name": "Имя:",
    "phone": "Телефон:",
    "username": "Username:",
    "branch": "Филиал:",
    "notSet": "не указан",
    "password": "ПАРОЛЬ",
    "changePassword": "Изменить пароль",
    "logout": "Выйти из аккаунта",
    "loadFail": "Не удалось загрузить данные профиля.",
    "theme": "ТЕМА ОФОРМЛЕНИЯ",
    "themeAuto": "Авто",
    "themeLight": "Светлая",
    "themeDark": "Тёмная",
    "language": "ЯЗЫК",
    "accent": "ЦВЕТОВАЯ ГАММА",
    "accentGreen": "Классическая",
    "accentRed": "Алая (как в приложении)",
    "accentBlue": "Синяя",
    "accentPurple": "Фиолетовая",
    "accentOrange": "Оранжевая",
    "accentTeal": "Бирюзовая",
    "accentPink": "Розовая"
  },
  "parcels": {
    "title": "Мои посылки",
    "addTitle": "Добавить посылку",
    "trackPh": "Введите трек номер",
    "descPh": "Описание (например: Куртка Zara)",
    "fillAll": "Заполните все поля",
    "notAuth": "Пользователь не авторизован",
    "added": "Закладка добавлена",
    "addError": "Ошибка при добавлении посылки",
    "archiveAll": "Архивировать все полученные",
    "archiveCount": "Архивировать {{count}} треков?",
    "archiveBtn": "Архивировать",
    "toArchive": "В архив",
    "archiveOne": "Добавить в архив?",
    "archived": "Архивировано {{done}} из {{total}} треков",
    "archivedOne": "Добавлено в архив",
    "noIssued": "Нет выданных треков",
    "deleteQ": "Удалить закладку?",
    "deleted": "Закладка удалена",
    "saved": "Закладка сохранена",
    "noBookmarks": "Нет закладок",
    "noHistory": "Нет истории",
    "showFull": "Показать полную историю",
    "collapse": "Свернуть историю",
    "editTitle": "Редактировать закладку",
    "trackNumber": "Трек номер",
    "description": "Описание",
    "errArchive": "Ошибка при архивировании",
    "errLoad": "Ошибка при получении закладок",
    "errDelete": "Ошибка при удалении закладки",
    "errSave": "Ошибка при сохранении закладки",
    "archiveAllTitle": "Архивировать все треки",
    "archiveOneTitle": "В архив"
  },
  "auth": {
    "loginTitle": "Вход в систему",
    "loginSubtitle": "Введите свой номер телефона и пароль",
    "login": "Войти",
    "noAccount": "Нет аккаунта? Зарегистрироваться",
    "forgot": "Забыли пароль?",
    "offer": "Публичная оферта",
    "regTitle": "Регистрация",
    "name": "Имя",
    "surname": "Фамилия (необязательно)",
    "usernamePh": "Код клиента — как в адресе",
    "codeHint": "Код клиента выдаёт представитель вашего филиала в личном сообщении.",
    "invitedBranch": "Филиал: {{name}}",
    "referrerPh": "Номер пригласившего (необязательно)",
    "inviteNotice": "Регистрация по коду клиента: его выдаёт представитель вашего филиала в личном сообщении. Введите код и тот номер телефона, на который вам его отправили.",
    "chooseBranch": "Выберите филиал",
    "passwordPh": "Придумайте пароль",
    "agree": "Согласен на обработку персональных данных и с",
    "terms": "условиями",
    "register": "Зарегистрироваться"
  },
  "status": {
    "expected": "Ожидаем",
    "arrivedWarehouse": "Прибыл на склад (已到仓库)",
    "sent": "Отправлен (已发货)",
    "arrivedBranch": "Прибыл в филиал (已达分部)",
    "arrivedAlmaty": "Прибыл в Алматы (已到阿拉木图)",
    "issued": "Выдан (已签收)",
    "ready": "Готов к выдаче",
    "inTransit": "В пути",
    "unknown": "Неизвестен"
  }
};

export default ru;
